import React from 'react';
import styled from 'styled-components';
import ProfileFormFields from './ProfileFormFields';

const Overlay = styled.div`position:fixed;inset:0;background:rgba(15,23,42,.5);display:flex;align-items:flex-start;justify-content:center;overflow-y:auto;padding:2rem 1rem;z-index:1000;`;
const Modal = styled.div`background:#fff;max-width:40rem;width:100%;padding:1.75rem;box-shadow:0 25px 60px rgba(15,23,42,.35);`;
const ModalTitle = styled.h2`margin:0 0 1.25rem;font-size:1.3rem;color:#111D4E;`;

// The "Edit my profile" popup, reached from the read-only view on
// AttendeeProfile.js. The first-time speaker onboarding flow does NOT use
// this - it's its own page (SpeakerInviteConfirmation.js), same as before
// profile unification, both sharing ProfileFormFields rather than duplicating it.
// fieldDiffs (organizer-proposed values, see AttendeeProfile.js) passes
// straight through with the rest of the props.
const ProfileEditModal = (props) => (
  <Overlay onClick={props.onCancel}>
    <Modal onClick={(e) => e.stopPropagation()}>
      <ModalTitle>{props.t('profile.editProfile', 'Edit my profile')}</ModalTitle>
      <ProfileFormFields {...props} />
    </Modal>
  </Overlay>
);

export default ProfileEditModal;
